import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Fund } from 'types'

type State = {
  currentFund: Fund | null
}

const initialState: State = {
  currentFund: null,
}

export const sliceFunds = createSlice({
  initialState,
  name: 'funds',
  reducers: {
    setCurrentFund: (state, { payload }: PayloadAction<Fund>) => {
      state.currentFund = payload
    },
    setCurrentFundStatus: (state, { payload }: PayloadAction<Partial<Fund>[]>) => {
      const fund = payload.find((f) => f.id === state.currentFund?.id)
      if (fund) state.currentFund.status = fund?.status
    },
  },
})
export const { setCurrentFund, setCurrentFundStatus } = sliceFunds.actions
